import './src/styles/global.css';

import {
    wrapRootElement as rootWrapper,
    wrapPageElement as pageWrapper
} from "./wrap-with-provider";

export const wrapRootElement = rootWrapper;
export const wrapPageElement = pageWrapper;